export default __webpack_public_path__ + "static/media/Frontier_League_Logo.8c63b907.png";